import React from "react";
import GitHubIcon from "@material-ui/icons/GitHub";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import "../styles/Home.css";

function Home() {
  return (
    <div className="home">
      <div className="about">
        <h2> Hi, My Name is Sonal</h2>
        <div className="prompt">
          <p>A software developer with a passion for learning and creating.</p>
          <a href="https://www.facebook.com/sonam.tomar.7509836?mibextid=ZbWKwL" target={"_blank"} rel="noreferrer">
            <FacebookIcon />
          </a>
          <a href="https://www.linkedin.com/in/sonal-tomar-802307205" target={"_blank"} rel="noreferrer">
            <LinkedInIcon />
          </a>
          {/* <a href="https://github.com/TECHNICALHARI" target="_blank" rel="noreferrer">
            <GitHubIcon />
          </a> */}
        </div>
      </div>
      <div className="skills">
        <h1> Skills</h1>
        <ol className="list">
          <li className="item">
            <h2> Front-End</h2>
            <span>
              React.js, Redux, Next.js, HTML, CSS, SCSS,
              Tailwind CSS, Material Ui, Bootstrap, JavaScript and jQuery.
            </span>
          </li>
          <li className="item">
            <h2>Back-End</h2>
            <span>
             Basic knowledge of NodeJS, ExpressJs, MongoDB
            </span>
          </li>
        </ol>
      </div>
    </div>
  );
}

export default Home;
